export const ValueRowsWithHeading = ({
  heading = "Returns (%)",
  values = [],
}) => {
  return (
    <div className="value-rows-wrapper">
      <span className="main-heading-value">{heading}</span>
      <div className="value-rows">
        {values.map((item, index) => {
          const isNegative = parseFloat(item.value) < 0;
          return (
            <div key={index} className="value-container">
              <span className="label">{item.label}</span>
              <div
                className={`value-item ${isNegative ? "bg-red" : "bg-green"}`}
              >
                <span className="value-white">{item.value}</span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
